const scheduleFilterMobileState = ref(false)

export function useScheduleFilterMobileState() {
  return scheduleFilterMobileState
}
